import { Component } from 'react';
import { withTranslation } from 'react-i18next';

class DomainChecker extends Component {
    constructor() {
        super();
    }

    render() {
        const { item } = this.props;
        return <div className="domain-checker-box">{item?.message}</div>;
    }
}

export default withTranslation()(DomainChecker);
